// extracted by mini-css-extract-plugin
export default {"disabled":"PageCountControl_disabled__yOr0h","hint":"PageCountControl_hint__KEJ+D"};